import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertIconXs } from '@lichtblick/icons/svg/alert/alert-xs';
import classNames from 'classnames';
import { Checkbox as CheckboxAtom } from '../../atoms/checkbox';
import { FieldFooter } from '../../atoms/field-footer';
import { TextLabel } from '../../atoms/text-label';
import styles from './checkbox.module.scss';
/**
 * `Checkbox` is a flexible checkbox component that includes a customizable label and footer.
 * It provides a structured way to combine a checkbox with additional information.
 *
 * @property {ReactElement<typeof Checkbox>} children - The checkbox component itself.
 * @property {string} [className] - Additional CSS classes for the wrapper element.
 * @property {ReactElement<typeof FieldFooter>} [footer] - An optional footer, e.g., for additional information.
 * @property {ReactElement<typeof TextLabel>} label - The label for the checkbox.
 *
 * @example
 * ```tsx
 * <Checkbox
 *   label={<Checkbox.Label>Accept Terms & Conditions</Checkbox.Label>}
 *   footer={<Checkbox.Footer>More information</Checkbox.Footer>}
 * >
 *   <Checkbox.Checkbox checked={isChecked} onChange={handleCheckboxChange} />
 * </Checkbox>
 * ```
 */ export const Checkbox = ({ children, className, 'data-testid': dataTestId, errorMessage, footer, label, wide = false })=>// biome-ignore lint/a11y/noLabelWithoutControl: part of children
    /*#__PURE__*/ _jsx("label", {
        className: classNames(styles.label, className),
        "data-testid": dataTestId,
        children: /*#__PURE__*/ _jsxs("span", {
            className: classNames(styles.wrapper, {
                [styles.wide]: wide
            }),
            children: [
                children,
                /*#__PURE__*/ _jsx(TextLabel, {
                    children: label
                }),
                Boolean(footer) && /*#__PURE__*/ _jsx(FieldFooter, {
                    className: styles.footer,
                    "data-testid": "field-footer",
                    children: footer
                }),
                Boolean(errorMessage) && /*#__PURE__*/ _jsx(FieldFooter, {
                    className: styles['error-message'],
                    "data-testid": "field-error",
                    error: true,
                    icon: /*#__PURE__*/ _jsx(AlertIconXs, {}),
                    children: errorMessage
                })
            ]
        })
    });
Checkbox.Label = TextLabel;
Checkbox.Footer = FieldFooter;
Checkbox.Checkbox = CheckboxAtom;

//# sourceMappingURL=index.js.map